function buocBaoCao() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Báo cáo thu mua",
      content:
        "Xem tổng hợp sản lượng / giá trị theo khoảng ngày: thẻ chỉ số, biểu đồ và bảng chi tiết theo nhân viên, loại bơ, chủ vườn.",
    },
    {
      target: "#tour-quan-ly-bao-cao-bo-loc",
      title: "Bước 2 · Chọn khoảng ngày",
      content:
        'Đổi ngày ở đây là số liệu TỰ TẢI LẠI ngay, không có nút "Lọc dữ liệu" riêng như trang Chứng từ thu mua — đây là điểm khác hành vi dễ gây nhầm lẫn giữa 2 trang, đừng tưởng phải bấm thêm nút nào.',
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-bao-cao-chi-so",
      title: "Bước 3 · 4 chỉ số tổng hợp",
      content:
        "Số phiếu, khối lượng đã cân, thành tiền và số chủ vườn đã bán — tính riêng cho khoảng ngày đang chọn ở bộ lọc trên, tự cập nhật ngay khi đổi ngày.",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-bao-cao-bieu-do",
      title: "Bước 4 · Xu hướng theo ngày và loại bơ",
      content:
        "Biểu đồ cột giúp nhìn xu hướng khối lượng thu mua theo từng ngày; biểu đồ thanh ngang so tỷ trọng giữa các loại bơ — số ở đầu mỗi thanh là phần trăm trên tổng khối lượng.",
      placement: "top",
    },
    {
      target: "#tour-quan-ly-bao-cao-bang",
      title: "Bước 5 · Xem chi tiết từng nhóm",
      content:
        "Mỗi bảng tổng hợp (nhân viên/loại bơ/chủ vườn) — bấm vào một dòng để xem danh sách phiếu thu mua thuộc nhóm đó, rồi bấm tiếp vào 1 phiếu để xem trọn vẹn PO. Trang này KHÔNG xuất được Excel — muốn xuất phải sang trang Chứng từ thu mua.",
      placement: "top",
    },
  ];
}

export default buocBaoCao;
